import { Button } from '@material-tailwind/react'
import PropTypes from 'prop-types'
import { useRevalidator } from 'react-router-dom'

export const PageLayoutError = (props) => {
  const revalidator = useRevalidator()
  console.log('revalidator.state', revalidator.state)

  const {
    message = 'No se pudieron cargar los datos',
    hideButton = false
  } = props
  return (
    <div className='h-full flex justify-center items-center gap-4 flex-col text-red-500 p-5 bg-red-100 border border-red-500 rounded text-center '>
      {message}
      {!hideButton &&
        <Button
          className='w-fit'
          loading={revalidator.state === 'loading'}
          color='red'
          variant='filled'
          onClick={() => revalidator.revalidate()}
        >Volver a cargar</Button>
      }
    </div>
  )
}

PageLayoutError.propTypes = {
  message: PropTypes.string,
  hideButton: PropTypes.bool
}
